import { render, staticRenderFns } from "./UiFocusLock.vue?vue&type=template&id=b6225b22&scoped=true"
import script from "./UiFocusLock.vue?vue&type=script&lang=js"
export * from "./UiFocusLock.vue?vue&type=script&lang=js"
import style0 from "./UiFocusLock.vue?vue&type=style&index=0&id=b6225b22&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6225b22",
  null
  
)

export default component.exports